class KlarnaSDK {
  static init(session) {
    return new Promise((resolve, reject) => {
      try {
        Klarna.Payments.init({
          client_token: session.clientToken,
        });
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  static load(categoryId) {
    return new Promise((resolve, reject) => {
      try {
        Klarna.Payments.load({
          container: `#klarna_${categoryId}`,
          payment_method_category: categoryId,
        }, (res) => {
          resolve(res);
        });
      } catch (err) {
        reject(err);
      }
    });
  }
  
  static loadKlarnaOne() {
    return new Promise((resolve, reject) => {
      try {
        Klarna.Payments.load({
          container: '#KlarnaOne',
        }, (res) => {
          resolve(res);
        });
      } catch (err) {
        reject(err);
      }
    });
  }

  static update(categoryId, klarnaInformation) {
    return new Promise((resolve, reject) => {
      try {
        Klarna.Payments.load({
          container: `#klarna_${categoryId}`,
          payment_method_category: categoryId,
        },
        klarnaInformation,
        (res) => {
          resolve(res);
        });
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  static authorize(paymentMethod, authRequestBody) {
    return new Promise((resolve, reject) => {
      try {
        if (paymentMethod === 'klarna') {
          Klarna.Payments.authorize(
            {payment_method_category: ''},
            authRequestBody,
            resolve,
          );
        } else {
          Klarna.Payments.authorize(
            {payment_method_category: paymentMethod},
            authRequestBody,
            resolve,
          );
        }
      } catch (err) {
        reject(err);
      }
    });
  }
}

export default KlarnaSDK;
